export const processCoordinates = (coordinates) => {
  if (!coordinates || !Array.isArray(coordinates)) {
    console.warn('Invalid coordinates format:', JSON.stringify(coordinates, null, 2));
    return null;
  }

  const processed = coordinates.map(coord => {
    if (typeof coord === 'object') {
      if (coord.$numberDouble !== undefined) {
        return parseFloat(coord.$numberDouble);
      }
      if (coord.$numberInt !== undefined) {
        return parseFloat(coord.$numberInt);
      }
    }
    const parsed = parseFloat(coord);
    if (isNaN(parsed)) {
      console.warn('Invalid coordinate value:', coord);
      return null;
    }
    return parsed;
  });

  if (processed.length !== 2 || processed.some(coord => coord === null)) {
    console.warn('Invalid processed coordinates:', processed);
    return null;
  }

  return processed;
};

export const enrichVendor = (vendor, userLat, userLng) => {
  let coordinates = null;
  let source = null;

  if (vendor.dispensaryType === 'Delivery' && vendor.deliveryZone?.coordinates) {
    coordinates = processCoordinates(vendor.deliveryZone.coordinates);
    source = 'delivery';
  } else if (vendor.dispensaryType === 'Pickup' && vendor.storefrontAddress?.coordinates) {
    coordinates = processCoordinates(vendor.storefrontAddress.coordinates);
    source = 'storefront';
  } else if (vendor.dispensaryType === 'Pickup & Delivery') {
    if (vendor.storefrontAddress?.coordinates) {
      coordinates = processCoordinates(vendor.storefrontAddress.coordinates);
      source = 'storefront';
    } else if (vendor.deliveryZone?.coordinates) {
      coordinates = processCoordinates(vendor.deliveryZone.coordinates);
      source = 'delivery';
    }
  }

  if (!coordinates || coordinates.length !== 2) {
    console.warn(`Invalid coordinates for vendor ${vendor.dispensaryName}`, {
      type: vendor.dispensaryType,
      coordinates,
      source
    });
    console.log('Before enriching vendor products:', vendor.products);
    return null;
  }

  const [vLng, vLat] = coordinates;
  console.log(`Processing vendor: ${vendor.dispensaryName}, Source: ${source}, Coordinates: [${vLng}, ${vLat}]`);

  const R = 3963; // Earth's radius in miles
  const dLat = (vLat - userLat) * Math.PI / 180;
  const dLng = (vLng - userLng) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(userLat * Math.PI / 180) * Math.cos(vLat * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return {
    ...vendor,
    coordinates: [vLng, vLat],
    coordinateSource: source,
    milesAway: parseFloat(distance.toFixed(1)),
  };
};
